
import React from 'react'
import { Redirect } from "react-router-dom";
import acuadori_header from '../assets/acuadori_header.png'

class UiIntro extends React.Component {
    static defaultProps = {
        title: "Title",
        minHeight: '70vh',
        height: '90%',
        nextRoute: "",
        bg: 'bg-light'
    };

    constructor(props) {
        super(props);
        this.state = { active: false };
    }

    render() {
        const _style = { minHeight: this.props.minHeight, height: this.props.height };
        const _class = "container-fluid  d-flex align-items-center justify-content-center " + this.props.bg;
        return (
            <div className='m-3'>
                {this.state.active && <Redirect to={this.props.nextRoute} />}

                <div style={_style} className={_class} onClick={() => this.setState({ active: true })} >
                    <img className="header-logo" src={acuadori_header}
                        alt={<label className="text-success "><h1>{this.props.title}</h1></label>}
                    />
                </div>
            </div>
        );
    }
}

export default UiIntro;